import { Dictionary } from 'lodash'
import { BILL_TOKEN_FIELD } from '../features/InvoiceGenerator/constants'


const publicRoutePatterns = [
  /^\/dlt-forms\/[a-zA-Z0-9_-]+\/?$/,
  // Digital receipt v2 is customer-facing and never needs a staff session: the
  // bill token (or its absence — the page shows an "invalid link" state) is
  // handled by the page itself, so a customer is never sent to the CASA login.
  /^\/invoiceV2\/?$/,
]

const isPublicRoute = (pathname: string = window.location.pathname) =>
  publicRoutePatterns.some((pattern) => pattern.test(pathname))

const doesRouteTokenAuthenticated = () => {
  const currentUrl = new URL(window.location.href)
  const jwtBasedAuthUrlPatterns = [
    /^\/customer\/survey\/form\/[a-zA-Z0-9_.-]+$/
  ]
  for (const pattern of jwtBasedAuthUrlPatterns) {
    if (pattern.test(currentUrl.pathname)){
      return true;
    }
  }
  const urlAuthMap: Dictionary<() => boolean> = {
    '/invoice': () => currentUrl.searchParams.has(BILL_TOKEN_FIELD),
    '/invoice/report': () => currentUrl.searchParams.has(BILL_TOKEN_FIELD)
  }

  return urlAuthMap[currentUrl.pathname]
    ? urlAuthMap[currentUrl.pathname]()
    : false
}

export { doesRouteTokenAuthenticated, isPublicRoute }
